import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';
import type {
  AvailabilityEvent,
  CalendarEventHandlers,
  TourEvent,
  ZCalendarEvent,
} from '../../../../../../constants/TourCalendar';
import { Z_CALENDAR_EVENT_TYPE } from '../../../../../../constants/TourCalendar';
import { getIsAvailabilityEvent, getIsInProgressAvailabilityEvent } from '../../../../../../utils/calendarEventGetters';
import AvailabilityEventEditPopoverBody from '../../../AvailabilityEventEditPopoverBody';
import AvailabilityEventPreviewPopoverBody from '../../../AvailabilityEventPreviewPopoverBody';
import TourEventPopoverBody from '../../../TourEventPopoverBody';

export type CalendarEventPopoverProps = {
  event: ZCalendarEvent;
  displayEventEditPopover: boolean;
  handlers: CalendarEventHandlers;
  canEditTourDuration?: boolean;
  tourDuration: TourDuration;
};
const CalendarEventPopover = ({
  event,
  displayEventEditPopover,
  handlers,
  canEditTourDuration = false,
  tourDuration,
}: CalendarEventPopoverProps) => {
  const {
    onClose,
    onSaveClick,
    onDeleteClick,
    onEditClick,
    onDeclineClick,
    onConfirmClick,
    onCancelTourConfirmationClick,
  } = handlers;

  if (getIsAvailabilityEvent(event) || getIsInProgressAvailabilityEvent(event)) {
    if (displayEventEditPopover) {
      return (
        <AvailabilityEventEditPopoverBody
          event={event as AvailabilityEvent}
          onClose={onClose}
          onSaveClick={onSaveClick}
          canEditTourDuration={canEditTourDuration}
          tourDuration={tourDuration}
        />
      );
    }

    return (
      <AvailabilityEventPreviewPopoverBody
        event={event as AvailabilityEvent}
        onDeleteClick={onDeleteClick}
        onEditClick={onEditClick}
      />
    );
  }

  if (event.eventType === Z_CALENDAR_EVENT_TYPE.TOUR) {
    return (
      <TourEventPopoverBody
        event={event as TourEvent}
        onDeclineClick={onDeclineClick}
        onConfirmClick={onConfirmClick}
        onCancelTourConfirmationClick={onCancelTourConfirmationClick}
      />
    );
  }

  return null;
};

export default CalendarEventPopover;
